/**
 * Renders the onboarding overlay over the left menu
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { topBarHeight, mainNavWidth } from 'theme/uiConfig';
import { debounce } from 'lodash';

const RESIZE_DEBOUNCE_TIME = 100;

const styles = theme => ({
	root: {
		position: 'fixed',
		left: 0,
		top: topBarHeight,
		bottom: 60, // don't cover Xara logo
		width: `calc(${mainNavWidth}px - 1px)`, // border or shadow
		zIndex: theme.zIndex.drawer
	},
});

@withStyles(styles)
class OnboardingOverlay extends Component {

	constructor(props) {
		super(props);
		this.onResize = debounce(this.onResize.bind(this), RESIZE_DEBOUNCE_TIME);
		this.state = {
			node: null
		};
	}

	setNode(props) {
		this.setState({
			node: window.document.querySelector(`[data-oid="${props.oId}"]`)
		});
	}

	componentWillReceiveProps(props) {
		this.setNode(props);
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize);
		this.setNode(this.props);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
	}

	onResize() {
		this.setNode(this.props);
	}

	render() {
		const { root } = this.props.classes;
		const { node } = this.state;

		if (!node) {
			return null;
		}

		return (
			<div className={root} style={{ backgroundImage: this.backgroundStyle }} />
		);
	}

	get backgroundStyle() {
		const { node } = this.state;
		const { top, height } = node.getBoundingClientRect();
		const color = 'rgba(255, 255, 255, 0.81)';

		const coordA = `calc(${top}px - ${topBarHeight}px)`;
		const coordB = `calc(${top + height}px - ${topBarHeight}px)`;

		return `linear-gradient(
			to bottom, 
			${color} ${coordA}, 
			transparent ${coordA}, 
			transparent ${coordB}, 
			${color} ${coordB}
		)`;
	}

}

OnboardingOverlay.propTypes = {
	classes: PropTypes.object,
	oId: PropTypes.string.isRequired
};

export default OnboardingOverlay;


// WEBPACK FOOTER //
// ./src/components/OnBoardingWizard/OnBoardingOverlay.js